/** Libellé coupon client (SEGMENTS / customer entitlements). */
export function couponDisplayLabel(coupon) {
    if (!coupon) return "—";
    return (
        coupon.display_label
        || coupon.coupon_type_name
        || coupon.payload?.couponTypeSnapshot?.name
        || "Coupon"
    );
}

/** Libellé reward client liée à un coupon. */
export function rewardDisplayLabel(reward, rewardDefs = {}) {
    if (!reward) return "—";
    const fromDef = reward.reward_id ? rewardDefs[String(reward.reward_id)]?.name : null;
    return (
        reward.display_label
        || reward.reward_name
        || reward.payload?.rewardSnapshot?.name
        || fromDef
        || "Avantage"
    );
}

/** Transitions autorisées PATCH …/coupons/{id}/status */
export function allowedCouponStatusTargets(currentStatus) {
    const st = String(currentStatus || "").toUpperCase();
    if (st === "ISSUED" || st === "AVAILABLE") return ["USED", "EXPIRED"];
    if (st === "USED") return ["ISSUED", "EXPIRED"];
    return [];
}

export function canTransitionCouponStatus(currentStatus, targetStatus) {
    return allowedCouponStatusTargets(currentStatus).includes(
        String(targetStatus || "").toUpperCase(),
    );
}

const DEFAULT_STATUS_LABELS = {
    ISSUED: "Émis",
    AVAILABLE: "Émis",
    USED: "Utilisé",
    EXPIRED: "Expiré",
};

export function couponStatusLabel(status, catalogLabels) {
    const key = String(status || "").toUpperCase();
    if (catalogLabels?.[key]) return catalogLabels[key];
    return DEFAULT_STATUS_LABELS[key] || status || "—";
}
